import React from 'react';
import { Link } from 'react-router-dom';
import CompanyDetailsBlock from '../components/CompanyDetailsBlock';

const RefundPolicyPage = () => {
  return (
    <div className="min-h-[80vh] bg-stone-50 py-16 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-block px-4 py-1 bg-[#1F3D2B]/5 text-[#1F3D2B] text-xs tracking-[0.2em] uppercase rounded-full mb-3">
            VinePass Policy
          </div>
          <h1 className="font-serif text-4xl sm:text-5xl text-[#1F3D2B]">Refund Policy</h1>
        </div>

        <div className="bg-white border border-stone-200 rounded-2xl shadow-sm px-8 sm:px-12 py-12 space-y-8 text-stone-700 leading-relaxed">
          <section>
            <h2 className="font-serif text-xl text-[#1F3D2B] mb-3">Refund Requests</h2>
            <p>Refunds are managed by the event organiser. Requests may be submitted up to <strong>7 days before the event date</strong>, subject to the organiser's approval.</p>
          </section>

          <div className="border-t border-stone-100" />

          <section>
            <h2 className="font-serif text-xl text-[#1F3D2B] mb-3">Non-Refundable Fees</h2>
            <p>Booking and service fees are <strong>non-refundable</strong> under any circumstances.</p>
          </section>

          <div className="border-t border-stone-100" />

          <section>
            <h2 className="font-serif text-xl text-[#1F3D2B] mb-3">Cancellation by Organiser</h2>
            <p>In the event of cancellation by the organiser, a <strong>full refund will be issued within 14 days</strong>.</p>
          </section>

          <div className="border-t border-stone-100" />

          <section>
            <h2 className="font-serif text-xl text-[#1F3D2B] mb-3">Platform Responsibility</h2>
            <p>VinePass facilitates ticketing and payments but is <strong>not responsible for individual organiser refund decisions</strong>.</p>
          </section>

          <div className="border-t border-stone-100" />

          <section>
            <h2 className="font-serif text-xl text-[#1F3D2B] mb-3">How to Request a Refund</h2>
            <p>Log in to your VinePass account and open the <Link to="/my-tickets" className="text-[#1F3D2B] underline hover:no-underline">My Tickets</Link> page. Next to the relevant order, tap <em>Request Refund</em> and provide a brief reason. You will receive a decision from the organiser via email.</p>
            <p className="mt-3 text-sm text-stone-500"><strong className="text-[#1F3D2B]">Processing time:</strong> Approved refunds are processed within 7–10 business days back to your original payment method.</p>
          </section>

          <div className="border-t border-stone-100" />

          <section>
            <h2 className="font-serif text-xl text-[#1F3D2B] mb-3">Questions</h2>
            <p>If you need help, email <a href="mailto:info@vinepass.co.za" className="text-[#1F3D2B] underline hover:no-underline">info@vinepass.co.za</a>.</p>
          </section>

          <CompanyDetailsBlock />
        </div>

        <p className="text-center text-xs text-stone-400 mt-8">Last updated: May 2026</p>
      </div>
    </div>
  );
};

export default RefundPolicyPage;
